<template>
  <Dialog ref="dialog" @hide="$emit('cancel')" :persistent="persistent" />  
</template>

<script>
import Dialog from './Dialog'

export default {
  name: 'NameDlg',
  components: {
    Dialog,
  },
  props: ['title', 'label', 'name', 'persistent'],
  mounted() {
    this.$refs.dialog.show({
      type: '',
      title: this.title,
      message: '',
      query: {
        name: {
          label: this.label,
          value: this.name
        }
      },
      buttons: [
        {
          label: this.$t('GENERIC_OK'),
          close: true,
          default: true,
          callback: res => {
            this.$emit('ok', res.name.value)
          },
        },
        {
          label: this.$t('GENERIC_CANCEL'),
          close: true,
          callback: () => {
            this.$emit('cancel')
          }
        }
      ]
    })
  },
}
</script>

<style>

</style>
